import type { Course } from '../course/Course';
import type { SplatMapBaker } from './SplatMapBaker';

/**
 * Fairway has no geometry-sculpting role (unlike Green/Bunker) — real
 * fairways are just mown, not shaped differently from surrounding rough.
 * This renderer's only job is contributing the fairway weight to the
 * shared splat map, read directly from each Hole's own fairway region.
 */
export class FairwayRenderer {
  paintSplat(course: Course, baker: SplatMapBaker): void {
    for (const hole of course.holes) {
      baker.paintRegion(hole.def.fairway, 'r');
    }
  }
}
